import React from 'react';
import { Box, Typography, Stack } from "@mui/material";
import { useTranslation } from 'react-i18next';
import OfferingsPhoto1 from '../assets/offerings1.png';
import OfferingsPhoto2 from '../assets/offerings2.png';
import OfferingsPhoto3 from '../assets/offerings3.png';

export const Offerings = () => {
  const { t } = useTranslation();
  return (
    <Stack
     sx={{
      display: "flex",
      gap: {xs: 4, md: 8},
      maxWidth: "100vw",
     }}
    >
      <Typography
        variant='h3'
        sx={{
          fontSize: "2.5rem",
          fontWeight: 600,
          lineHeight: 1.45,
          textAlign: "center",
          mx: {xs:4, md: 0}
        }}
      >
        {t('website:plus.offerings.heading')}
      </Typography>
      <Stack
        display={"flex"}
        flexDirection={{xs: "column", md: "row"}}
        gap={0}
        justifyContent={"space-between"}
        sx={{
          '& h5': {
            color: "primary.light",
            fontWeight: 600,
            lineHeight: "normal",
          },
          '& p': {
            color: "#323232",
            fontSize: "1.125rem",
            fontWeight: 400,
            lineHeight: 1.75,
          },
          mx: {xs:4, md: 0},
          gap: {xs: 4, md: 0}
        }}
      >
        <Stack
          flexDirection={{xs: "column-reverse", md:"column"}}
          gap={4}
          flex={1}
        >
          <Stack
            flexDirection={"row"}
            gap={4}
            justifyContent={'space-between'}
          >
            <Box
              maxWidth={{xs: 184, sm: 266}}
              maxHeight={{xs: 209, sm: 332}}
              mt={{xs: 0, md: 12}}
            >
              <img
                className="small-logo"
                src={OfferingsPhoto2}
                alt={'OfferingsPhoto2'}
                loading="lazy"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: 8
                }}
              />
            </Box>
            <Box
              maxWidth={{xs: 184, sm: 266}}
              maxHeight={{xs: 209, sm: 332}}
              mr={{xs: 0, md: 8}}
              mb={{xs: 0, md: 12}}
            >
              <img
                className="small-logo"
                src={OfferingsPhoto1}
                alt={'OfferingsPhoto1'}
                loading="lazy"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: 8
                }}
              />
            </Box>
          </Stack>
          <Stack gap={2}>
            <Typography variant='h5'>
              {t('website:plus.offerings.dps.title')}
            </Typography>
            <Typography variant='body2'>
              {t('website:plus.offerings.dps.description1')}
            </Typography>
            <Typography variant='body2'>
              {t('website:plus.offerings.dps.description2')}
            </Typography>
          </Stack>
        </Stack>
        <Stack
          flexDirection={"column"}
          justifyContent={"space-between"}
          flex={1}
        >
          <Stack gap={2}>
            <Typography variant='h5'>
              {t('website:plus.offerings.frameworkAgreements.title')}
            </Typography>
            <Typography variant='body2'>
              {t('website:plus.offerings.frameworkAgreements.description')}
            </Typography>
          </Stack>
          <Box display={{xs: 'none', md: 'flex'}}>
            <img
              className="small-logo"
              src={OfferingsPhoto3}
              alt={'OfferingsPhoto3'}
              loading="lazy"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: 8
              }}
            />
          </Box>
        </Stack>
      </Stack>
    </Stack>
  )
}